import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { WhatsappLogo, ArrowRight } from "@phosphor-icons/react";
import { useAuth } from "../lib/auth";
import TopBar from "../components/TopBar";

export default function CompleteProfile() {
  const { user, saveWhatsapp } = useAuth();
  const nav = useNavigate();
  const location = useLocation();
  const [number, setNumber] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    const res = await saveWhatsapp(number);
    setLoading(false);
    if (!res.ok) return setError(res.error);
    toast.success("Thanks! You're all set.");
    nav(location.state?.from || "/dashboard", { replace: true });
  };

  return (
    <div className="min-h-screen">
      <TopBar />
      <div className="max-w-md mx-auto px-6 py-16">
        <form onSubmit={submit} className="neu rounded-3xl p-8 sm:p-10" data-testid="complete-profile-form">
          <div className="w-12 h-12 rounded-full neu-sm flex items-center justify-center text-indigo">
            <WhatsappLogo size={22} weight="duotone" />
          </div>
          <h1 className="mt-6 text-3xl font-bold text-foreground tracking-tight">One last step{user?.name ? `, ${user.name.split(" ")[0]}` : ""}</h1>
          <p className="mt-3 text-sm text-foreground/75">Add your WhatsApp number so we can follow up on your results. You'll need it before taking the test.</p>
          <label htmlFor="wa" className="overline block mt-8">WhatsApp number</label>
          <input
            id="wa"
            autoFocus
            type="tel"
            value={number}
            onChange={(e) => setNumber(e.target.value)}
            placeholder="+44 7700 900123"
            data-testid="complete-profile-whatsapp-input"
            className="neu-input w-full mt-3 px-5 py-4"
          />
          {error && (
            <div data-testid="complete-profile-error" className="mt-4 text-sm text-red-500 neu-inset-sm px-4 py-3 rounded-xl">{error}</div>
          )}
          <button
            type="submit"
            disabled={loading || number.trim().length < 6}
            data-testid="complete-profile-submit-btn"
            className="neu-btn-primary mt-8 w-full inline-flex items-center justify-center gap-2 px-8 py-4 font-medium disabled:opacity-60"
          >
            {loading ? "Saving…" : "Continue"} {!loading && <ArrowRight size={16} weight="bold" />}
          </button>
        </form>
      </div>
    </div>
  );
}
